import { reactQueryUtils } from "@lib/react-query";
import { useQuery } from "@tanstack/react-query";
import { apiKeysApi } from "./api-keys.api";
import { apiKeysKeys } from "./api-keys.keys";
import type {
  TApiKey,
  TAutomationQueryParams,
  TAutomationQueryResponse,
} from "./types";

export const useGetApiKeysQuery = (options = {}) => {
  return useQuery({
    queryKey: apiKeysKeys.apiKeys,
    queryFn: () => apiKeysApi.getApiKeys(),
    ...options,
  });
};

export const useLazyGetApiKeysQuery = () => {
  return {
    query: async (omitCache?: boolean) => {
      if (!omitCache) {
        const cache = reactQueryUtils.getQueryData<TApiKey[]>([
          ...apiKeysKeys.apiKeys,
        ]);
        if (cache) return cache;
      }
      const data = await apiKeysApi.getApiKeys();
      reactQueryUtils.setQueryData([...apiKeysKeys.apiKeys], data);
      return data;
    },
  };
};

export const useGetApiUsageQuery = (options = {}) => {
  return useQuery({
    queryKey: apiKeysKeys.apiUsage,
    queryFn: () => apiKeysApi.getApiUsage(),
    ...options,
  });
};

// General automation query hook - supports any query type
export const useQueryAutomationQuery = <T extends string | string[]>(
  params: TAutomationQueryParams & { query: T },
  enabled = true,
  options = {},
) => {
  return useQuery<TAutomationQueryResponse<T>>({
    queryKey: apiKeysKeys.automation(params),
    queryFn: () => apiKeysApi.queryAutomation(params),
    enabled: enabled && !!params.query && !!params.dateFrom && !!params.dateTo,
    ...options,
  });
};
